import { osTypes } from '../types';

export function getProductChangelogLink(productType: any, isPartner: boolean): string {
  switch (productType) {
    case osTypes.linux:
      return isPartner ? 'https://www.bitdefender.com/business/support/en/77211-77513-linux-agent.html' : 'https://www.bitdefender.com/business/support/en/77209-77513-linux-agent.html';
    case osTypes.mac:
      return isPartner ? 'https://www.bitdefender.com/business/support/en/77211-78218-macos-agent.html' : 'https://www.bitdefender.com/business/support/en/77209-78218-macos-agent.html';
    case osTypes.windows:
    default:
      return isPartner ? 'https://www.bitdefender.com/business/support/en/77211-77540-windows-agent.html' : 'https://www.bitdefender.com/business/support/en/77209-77540-windows-agent.html';
  }
}
